import MeetingTimes from "./MeetingTimes";
import { Popup } from "../../../share/components/Popup.tsx/Popup";
import { PopupAction } from "../../../core/types/PopupAction";
import { useState } from "react";
import { Exhibitor } from "../../../core/types/Exhibitor.model";
import { Meeting } from "../../../core/types/Meeting.model";
import { SalesPerson } from "../../../core/types/SalesPerson.model";
import { TypingDots } from "../../../share/components/TypingDots/TypingDots";

interface ConformSlotPopupProps {
    selectedSlot: Meeting;
    selectedSalesPerson: SalesPerson;
    selectedExhibitor: Exhibitor;
    selectedDate: string;
    exhibitorLogo: string;
    exhibitorProfile: string | null | undefined;
    onSlotConfirm: (comment?: string) => void;
    onClose: () => void;
    isLoaded: boolean;
}
const ConformSlotPopup = ({
    selectedSlot,
    selectedSalesPerson,
    selectedExhibitor,
    selectedDate,
    exhibitorLogo,
    exhibitorProfile,
    onSlotConfirm,
    onClose,
    isLoaded,
}: ConformSlotPopupProps) => {
    const [comment, setComment] = useState("");
    const [showOverlapWarning, setShowOverlapWarning] = useState(true);

    if (!selectedSlot || !selectedSalesPerson || !selectedExhibitor) return null;

    const onClosePopupAction: PopupAction = {
        label: 'Cancel',
        className: 'btn-secondary',
        callback: onClose
    }

    const onConformAction: PopupAction = {
        label: 'Confirm',
        className: 'btn-success',
        callback: () => onSlotConfirm(comment)
    }

    return (
        <Popup closeAction={onClosePopupAction} actions={[onConformAction]}>
            {isLoaded && <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(255, 255, 255, 0.8)", // רקע חצי שקוף
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999, // מעל הכול
            }}>
                <div className="loader"></div>
            </div>}
            <div className="card shadow-sm">
                <div className="card-body">
                    <div className="d-flex align-items-center mb-4 justify-content-between">
                        <div>
                            <h5 className="card-title fw-semibold text-dark mb-0 me-3 pt-3">1:1 Meeting with {selectedExhibitor.origName}</h5>
                        </div>

                        {exhibitorLogo && <img src={exhibitorLogo} alt={selectedExhibitor.origName} style={{ maxHeight: '150px', maxWidth: '150px', objectFit: 'contain', alignSelf: 'baseline' }} />}

                    </div>
                    <div className="">
                        {exhibitorProfile && <p className="text-muted small mb-3">{exhibitorProfile}</p>}
                        {!exhibitorProfile && <TypingDots />}
                    </div>
                    <div>
                        <h6 className='pt-2 pb-1'> representative: {selectedSalesPerson.fullName}</h6>
                        <div className="d-flex align-items-center gap-2 gap-sm-4 flex-wrap">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-calendar-event text-primary me-2"></i>
                                <span className="small fw-medium">{selectedDate}</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <i className="bi bi-clock text-primary me-2"></i>
                                <span className="small fw-medium"><MeetingTimes selectedSalesPerson={selectedSalesPerson} selectedDate={selectedDate} /> </span>
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 p-1 mt-4">
                        <label htmlFor="meetingNote" className="form-label fw-bold">
                            What would you like to talk about? (optional)
                        </label>
                        <textarea
                            id="meetingNote"
                            className="form-control"
                            rows={3}
                            maxLength={200}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Write your note here..."
                        />
                    </div>


                </div>
            </div>

            {selectedSlot.hasOverlap && showOverlapWarning && (
                <div
                    className="alert alert-danger mt-3 position-relative d-flex gap-2"
                    role="alert"
                    style={{
                        borderRadius: 12,
                        border: "1px solid rgba(220, 53, 69, 0.35)",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                        paddingRight: "2.75rem",
                    }}
                >
                    <i className="bi bi-exclamation-triangle-fill fs-5 mt-1"></i>

                    <div className="flex-grow-1">
                        <div className="fw-semibold mb-1">Scheduling conflict</div>
                        <div className="small">
                            You have other meetings scheduled during this time. Confirming this slot may lead to conflicts.
                        </div>
                        <button
                            type="button"
                            className="btn btn-link p-0 fw-semibold"
                            onClick={() => {
                                setShowOverlapWarning(false);
                                onClose(); // go back and pick a different time
                            }}
                            style={{  color: '--bs-alert-color: var(--bs-danger-text-emphasis)' }}
                        >
                            Click here to choose a different time
                        </button>
                    </div>

                    <button
                        type="button"
                        aria-label="Close"
                        className="btn btn-sm position-absolute top-0 end-0 m-2"
                        onClick={() => setShowOverlapWarning(false)}
                        style={{
                            width: 32,
                            height: 32,
                            borderRadius: 999,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 0,
                        }}
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>
            )}


        </Popup>
    );
};

export default ConformSlotPopup;
